import { useState, useEffect } from 'react';
import { useNavigate, Navigate, useLocation } from 'react-router-dom';
import { api, getToken } from '../api';
import PaulaChat from './PaulaChat';

function Tab({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        flex: 1, padding: '14px 8px',
        background: 'none', border: 'none',
        borderBottom: active ? '1px solid var(--gold)' : '1px solid transparent',
        color: active ? 'var(--gold)' : 'rgba(255,255,255,0.28)',
        fontSize: 10, fontWeight: 400, letterSpacing: 2,
        textTransform: 'uppercase', cursor: 'pointer',
        transition: 'color 0.2s, border-color 0.2s',
      }}
    >
      {label}
    </button>
  );
}

function MatchesTab() {
  const navigate = useNavigate();
  const [mutualMatches, setMutualMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [opening, setOpening] = useState(null);

  useEffect(() => {
    api.get('/mutual-matches')
      .then(data => { setMutualMatches(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const openChat = async (targetUserId, name) => {
    setOpening(targetUserId);
    try {
      const { channel_id } = await api.post('/chat/channel', { target_user_id: targetUserId });
      navigate(`/chat/${channel_id}`, { state: { name } });
    } catch {
      setOpening(null);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 80 }}>
        <span className="spinner" />
      </div>
    );
  }

  if (mutualMatches.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '60px 24px 0' }}>
        <div style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic', fontSize: 18, fontWeight: 300, color: 'var(--muted)', marginBottom: 12 }}>
          No mutual matches yet
        </div>
        <div style={{ fontSize: 13, color: 'var(--very-muted)', fontWeight: 300, lineHeight: 1.7 }}>
          When you and a match both say Interested,<br />they'll appear here.
        </div>
        <button className="btn-ghost" style={{ marginTop: 32 }} onClick={() => navigate('/matches')}>
          View your matches
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: '8px 0' }}>
      {mutualMatches.map(m => (
        <div
          key={m.matched_user_id}
          className="chat-row"
          style={{ padding: '18px 24px' }}
          onClick={() => openChat(m.matched_user_id, m.name)}
        >
          <div className="chat-row-avatar">
            {m.photo_url
              ? <img src={m.photo_url} alt={m.name} className="chat-row-photo" />
              : <div className="chat-row-initial">{m.name?.[0]}</div>
            }
          </div>
          <div className="chat-row-info">
            <div className="chat-row-name">{m.name}</div>
            <div className="chat-row-sub">You both said yes</div>
          </div>
          <div className="chat-row-arrow">
            {opening === m.matched_user_id ? '...' : '→'}
          </div>
        </div>
      ))}
    </div>
  );
}

export default function Chats() {
  const location = useLocation();
  const [tab, setTab] = useState(location.state?.tab || 'matches');

  if (!getToken()) return <Navigate to="/login" replace />;

  return (
    <div style={{ height: '100vh', background: '#000', display: 'flex', flexDirection: 'column' }}>

      {/* Header */}
      <div style={{ padding: '52px 24px 0', flexShrink: 0 }}>
        <div className="display-sm" style={{ marginBottom: 20 }}>Conversations</div>
      </div>

      {/* Tabs */}
      <div style={{
        flexShrink: 0, display: 'flex',
        borderBottom: '0.5px solid rgba(255,255,255,0.08)',
        margin: '0 0 0 0',
      }}>
        <Tab label="Your matches" active={tab === 'matches'} onClick={() => setTab('matches')} />
        <Tab label="Paula: Matchmaker" active={tab === 'paula'} onClick={() => setTab('paula')} />
      </div>

      {/* Content */}
      <div style={{ flex: 1, overflow: tab === 'paula' ? 'hidden' : 'auto', display: 'flex', flexDirection: 'column', paddingBottom: tab === 'paula' ? 0 : 100 }}>
        {tab === 'matches' ? <MatchesTab /> : <PaulaChat />}
      </div>

    </div>
  );
}
